export default __webpack_public_path__ + "static/media/aluminum.f0cf1dc4.png";